import gql from 'graphql-tag';

export const NAME = 'compositions_Cases_HighlightedCasesQuery';

export default gql`
  query ${NAME} ($sort: CaseSort, $before: String, $after: String, $pageSize: Int) {
    highlightedCases(input: { sort: $sort }) {
      cases(first: $pageSize, before: $before, after: $after) {
        edges {
          node {
            id
            caseNumber
            assignedTo { email firstName lastName }
            status
            inboundProgramNumber { id customerName }
            assetDowntimeMs
            createdAt
            customer(useCachedDataForCase: true) {
              ...on Customer { id customerName: name }
              ...on StoreCustomer { id storeCustomerName: name }
              ...on CustomCustomer { name }
              ...on CustomStoreCustomer { name }
            }
            isDelayed
            caseDelays {
              id
              startTime
              endTime
              reasonType
              customReason
              status
            }
            quickNote
            primaryAsset { id unitNumber }
            statusHistory { id oldStatus newStatus changedAt createdAt }
            servicingDealer {
              id
              eta { id minMinutes maxMinutes }
              dealer {
                ...on Dealer { id name address { city province postalCode }}
                ...on CustomDealer { id name }
              }
            }
            isDelayedService
            delayedServiceNotes
            assetLocationTimezone
            delayedServiceScheduledDate
            delayedServiceScheduledDispatchDate
          }
        }
        pageInfo {
          startCursor endCursor
          hasNextPage hasPreviousPage
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CasesSearch/withHighlightedCasesResults/highlightedCasesQuery.js